






// @ is an alias to /src
import { Vue, Component } from 'vue-property-decorator';
import PermUtil from '@/model/PermUtil';
import { COLLECTION_ORGANIZATIONS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import StatusType from '@/model/typelist/StatusType';

@Component({
  components: {
  },
})
export default class Admin extends Vue {
  mounted() {
    this.$store.dispatch('bindWaitingOrganizations');
  }

  get Orgs() {
    return this.$store.state.WaitingOrganizations;
  }
  // eslint-disable-next-line
  get showRegister() {
    return PermUtil.canCreateOrganization();
  }
  // eslint-disable-next-line
  accept(org: any) {
    const clone = { ...org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, org.moderator.uid);
    clone.status = { ...StatusType.approved };
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: org.id,
      payload: clone,
    });
  }

  deleted(org: any) {
    this.$store.dispatch('removeFromCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      payload: org.id,
    });
  }
}
